"use client"

import {
  LayoutGeneral,
  LayoutGeneralProps,
} from "@/components/terra/layouts/LayoutGeneral/LayoutGeneral"
import { ThemeDivider } from "@/components/terra/component/ThemeDivider/ThemeDivider"

import { documentToHtmlString } from "@contentful/rich-text-html-renderer"
import { handleButtons } from "@/lib/utils"

export default function MXPLayoutGeneral(props: any) {
  const { value, index, divider, headerElement, isLCP, lang } = props

  const buttons: any[] = handleButtons(value.buttonsCollection?.items, true, lang)

  let image = null
  if (value.imageCollection?.items?.[0]?.image) {
    const sImage = value.imageCollection?.items?.[0]
    image = {
      imageType: sImage?.__typename || "unknown",
      title: sImage?.title,
      url: sImage?.image.url,
      alt: sImage?.altText,
      x: sImage?.focalPoint?.focalPoint?.x,
      y: sImage?.focalPoint?.focalPoint?.y,
      width: sImage?.image.width,
      height: sImage?.image.height,
      focusArea: sImage?.focusArea,
    }
  }

  const orientationValue = value.orientationBoolean ? "left" : "right"
  const dividerClasses = `section-divider-wrap ${value.theme}`
  return (
    <>
      <LayoutGeneral
        key={index}
        eyebrow={value.eyebrow}
        header={value.header}
        subheader={value.subheader}
        description={documentToHtmlString(value.description?.json) || ""}
        image={image as LayoutGeneralProps["image"]}
        presetTheme={value.theme}
        buttons={buttons}
        orientation={orientationValue}
        isWrapped={true}
        isHeaderBig={value.isHeaderBig || false}
        componentImagePriority={value?.componentImagePriority}
        headerElement={headerElement}
        isLCP={isLCP}
      />
      {divider && (
        <div className={dividerClasses}>
          <ThemeDivider currentTheme={value.theme} />
        </div>
      )}
    </>
  )
}
